import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useStore = create(
  persist(
    (set) => ({
      vendorId: null,
      locationId: null,
      staffId: null,
      userRole: null, // "vendor" or "staff" (or "manager")
      
      // Cached data to prevent excessive loading spinners
      userData: null,
      transactions: [],
      transactionsLoaded: false,
      locationsCount: null,
      
      locations: [],
      locationsLoaded: false,
      
      setUserData: (data) => set({ userData: data }),
      setTransactions: (data) => set({ transactions: data, transactionsLoaded: true }),
      setLocationsCount: (count) => set({ locationsCount: count }),
      setLocations: (locations) => set({ locations, locationsLoaded: true }),

      setSessionContext: (context) => set({ 
        vendorId: context.vendorId || null, 
        locationId: context.locationId || null, 
        staffId: context.staffId || null,
        userRole: context.userRole || null
      }),

      clearSessionContext: () => set({ 
        vendorId: null, 
        locationId: null, 
        staffId: null,
        userRole: null,
        userData: null,
        transactions: [],
        transactionsLoaded: false,
        locationsCount: null
      })
    }),
    {
      name: 'americar-vendor-storage', // unique name for localStorage access
    }
  )
);

export default useStore;
